import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar'; // Import MatSnackBar

import { BannerEnquiryFormComponent } from '../../Modules/banner-enquiry-form/banner-enquiry-form.component';
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, HttpClientModule, MatSnackBarModule,],
  standalone: true,
})
export class HomePageComponent implements OnInit {
  compactForm: FormGroup;
  isFormSubmitted = false;
  baseUrl = environment.baseUrl;
  constructor(private http: HttpClient, private snackBar: MatSnackBar) {

    this.compactForm = new FormGroup({
      full_name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone: new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
        Validators.minLength(8),
      ]), // Phone
      appointment_date: new FormControl(''),
      loan_type_id: new FormControl(19, [Validators.required]), // Default loan type ID
      organization_id: new FormControl(1, [Validators.required]), // Default organisation ID
      enq_detail_msg: new FormControl('', [Validators.required]), // Message
    });
  }

  socialMedia = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/profile.php?id=100080684341899',
      iconClass: 'fab fa-facebook-f',
    },
    {
      name: 'Twitter',
      url: 'https://x.com/snpmoney75267',
      iconClass: 'fab fa-twitter',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/snpmoney/profilecard/?igsh=aWN3bHhkamQ2eGpz',
      iconClass: 'fab fa-instagram',
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/company/snp-wealth-pvt-ltd/?viewAsMember=true',
      iconClass: 'fab fa-linkedin-in',
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@SNPMoney-j4s',
      iconClass: 'fab fa-youtube',
    },
  ];

  ngOnInit(): void {}

  onSubmit() {
    if (this.compactForm.valid) {
      const formData = { ...this.compactForm.value };

      console.log('Compact Form Submission Object:', formData);

      this.http.post(`${this.baseUrl}/add_basic_enquiry`, formData).subscribe({
        next: (res: any) => {
          console.log('Response from API:', res);
          if (res.success) {
            console.log('Submission successful!');
            this.isFormSubmitted = true;
            this.snackBar.open(
              'Enquiry Added successful! Thank you for your enquiry!',
              'Close',
              { duration: 5000 }
            ); // Show success Snackbar

            // Reset the form
            this.compactForm.reset();

            // Hide the success message after 5 seconds
            setTimeout(() => {
              this.isFormSubmitted = false;
            }, 5000);
          } else {
            console.log('Submission failed:', res);
            this.snackBar.open(
              'Submission failed. Please try again.',
              'Close',
              { duration: 5000 }
            ); // Show error Snackbar
          }
        },
        error: (err: any) => {
          console.log('Error during submission:', err);
          this.snackBar.open('An error occurred. Please try again.', 'Close', {
            duration: 5000,
          }); // Show error Snackbar
        },
      });
    } else {
      console.log('Form is invalid:', this.compactForm.errors);
      this.snackBar.open('Please fill in all required fields.', 'Close', {
        duration: 5000,
      }); // Show validation error Snackbar
    }
  }
}
